import { API } from "@/lib/api";
import {
  APIService,
  FetchListRequest,
  SuccessFetchListResponse,
  SuccessUpdateItemResponse,
} from "@/services/api";
import {
  CancelContractorVisit,
  ConfirmContractorVisit,
  CreateContractorVisit,
  ReadContractorVisit,
  SummaryContractorVisit,
  UpdateContractorVisit,
} from "@/types/contractorVisit";
import { RoleBasedProjectSettlementType } from "@/modules/projects/service/settlementType";

const service = new APIService<ReadContractorVisit>(API.ContractorVisits);

export const ContractorVisitsService = {
  getList: (params: FetchListRequest<ReadContractorVisit>) =>
    service.getList(params),

  getSummary: (
    projectId: string,
    storeId: string,
    period: string,
  ): Promise<SuccessFetchListResponse<SummaryContractorVisit>> =>
    service.getStaticList<SuccessFetchListResponse<SummaryContractorVisit>>(
      `/period-summary?project_id=${projectId}&store_id=${storeId}&period=${period}`,
    ),

  get: (id: string) => service.get(id),

  patch: async (visits: UpdateContractorVisit[]) => {
    const response = await service.performFetch(service.path, "PATCH", visits);
    await service.handleResponseError(response);
    const json =
      (await response.json()) as SuccessUpdateItemResponse<ReadContractorVisit>;
    return json.data;
  },

  post: async (visit: CreateContractorVisit) => {
    const response = await service.performFetch(service.path, "POST", visit);
    await service.handleResponseError(response);
    const json =
      (await response.json()) as SuccessUpdateItemResponse<ReadContractorVisit>;
    return json.data;
  },

  cancel: (id: string, payload: CancelContractorVisit) =>
    service.patch(id, payload, "cancel"),

  confirm: (id: string, payload: ConfirmContractorVisit) =>
    service.patch(id, payload, "confirm"),

  delete: (id: string) => service.delete(id),

  getSettlementType: async (
    projectRoleId: string,
    storeId: string,
  ): Promise<RoleBasedProjectSettlementType | null> => {
    return service.getStaticList<RoleBasedProjectSettlementType | null>(
      `/settlement-type?project_role_id=${projectRoleId}&store_id=${storeId}`,
    );
  },
};
